<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<ng-container [formGroup]="group">
  <fieldset
    class="dynamic-form-group__fieldset"
    [formGroupName]="model.id"
    [id]="id"
    [attr.data-name]="model.name"
    [ngClass]="getClass('element', 'control')"
  >
    @if (model.legend) {
      <legend class="dynamic-form-group__legend">{{ model.legend }}</legend>
    } @else {
      <legend class="profile:sr-only">{{ model.name }}</legend>
    }
    @for (_model of model.group; track _model) {
      <dynamic-form-control
        [group]="$any(control)"
        [hidden]="_model.hidden"
        [layout]="formLayout"
        [model]="_model"
        [hostClass]="[getClass('element', 'children'), getClass('grid', 'children')]"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)"
        (metaDataSelectedEvent)="metaDataSelected($event)"
      ></dynamic-form-control>
    }
  </fieldset>
</ng-container>
